import { VideoDataImpl } from './VideoDataImpl';
import { Platform } from './Platform';
import { RenderDevice } from './RenderDevice';
import { VideoSprite } from './VideoSprite';
import { Compatibility } from '../helpers/compatibility';
import { Rect } from './Rect';
import { Vector2 } from './Vector2';

export class VideoDataWebGL extends VideoDataImpl {
  private readonly _platform: Platform;
  private readonly _renderDevice: RenderDevice;

  private _canvas: HTMLCanvasElement;
  private _canvasContext: CanvasRenderingContext2D;

  constructor(platform: Platform, renderDevice: RenderDevice, video: HTMLVideoElement) {
    super(video);
    this._platform = platform;
    this._renderDevice = renderDevice;
  }

  public clone(): VideoDataWebGL {
    return new VideoDataWebGL(this._platform, this._renderDevice, this.cloneVideoElement());
  }

  public createSprite(): VideoSprite {
    const texture = this._renderDevice.createTextureFromVideo(this.video)!;

    if (Compatibility.IsIE || Compatibility.IsFirefox5) {
      this._canvas = document.createElement('canvas');
      this._canvas.width = texture.width;
      this._canvas.height = texture.height;

      this._canvasContext = this._canvas.getContext('2d')!;
    }

    return new VideoSprite(
      texture,
      new Rect(Vector2.Zero, new Vector2(texture.width / 2, texture.height))
    );
  }

  public updateSprite(sprite: VideoSprite): void {
    const revision = this._platform.frame;
    if (sprite.revision !== revision) {
      if (this._canvas) {
        this._canvasContext.drawImage(
          this.video,
          0,
          0,
          this._canvas.width,
          this._canvas.height,
          0,
          0,
          this._canvas.width,
          this._canvas.height
        );

        this._renderDevice.updateTextureFromCanvas(sprite.texture, this._canvas);
      } else {
        this._renderDevice.updateTextureFromVideo(sprite.texture, this.video);
      }

      sprite.revision = revision;
    }
  }

  public destroySprite(sprite: VideoSprite): void {
    if (sprite.texture) {
      sprite.texture.dispose();
      sprite.texture = null;
    }
  }
}
